__turbopack_context__.v({
  "hasIcon": "BucketHeader-module-scss-module__c79X0a__hasIcon",
  "premium": "BucketHeader-module-scss-module__c79X0a__premium",
  "root": "BucketHeader-module-scss-module__c79X0a__root",
  "subtitle": "BucketHeader-module-scss-module__c79X0a__subtitle",
  "title": "BucketHeader-module-scss-module__c79X0a__title",
});
